<template>
    <div class="bg-white">
        <CContainer>
            <br />
            <CRow class="header-row mb-3 position-relative">
                <!-- Back Button on the Left -->
                <CCol class="col-auto">
                    <CButton class="back-button" @click="goBack">
                        ←
                    </CButton>
    
                </CCol>
    
                <!-- Centered Title -->
                <CCol class="d-flex flex-column align-items-center position-absolute start-50 translate-middle-x">
                    <h3 class="section-title m-0">{{posit.Position}}</h3>
                    <p class="custom-12px-500 font-color-928AFD mt-2">AI Summary</p>
                </CCol>
            </CRow>
            <div class="w-100 mt-5">
                <br />
                <CContainer>
                    <div class="text-center" v-if="questionVideo && questionVideo.IndexNo !== undefined">
                        <iframe :src="questionVideo.Url" frameborder="0" allowfullscreen style="width: 100%;height:450px"></iframe>
    
                    </div>
                    <CRow>
                        <!-- <CCol sm="10">
                                <label class="ml-2 mr-2 mt-2 font-color-171717">
                                                                    Current Video Question: {{ questionVideo.IndexNo }}
                                                                </label>
                            </CCol>
                            <CCol sm="2">
                                <span class="custom-border-purple p-2 text-center text-white" style="background:#2cb85c" @click="nextQuestion(questionVideo.IndexNo)">
                                                                    <label class="ml-2 mr-2 mt-2">Next Video</label>
                                                                </span>
                            </CCol> -->
                        <!-- <CCol sm="12" class="text-left">
                            <h4 class="mt-2 font-color-171717">Question:</h4>
                            <p class="font-color-171717">🔹 {{ questionVideo.Question }}</p>
                            <h4 class="font-color-171717">Answer:</h4>
                            <p class="font-color-171717">🔹 {{ questionVideo.Answer }}</p>
                        </CCol> -->
    
<!--     
                        <CCol sm="5" class="p-0">
    
                            <h3 class="custom-18px-500 font-inter mt-2">
                                4 personal character indicators
                            </h3>
                            <CCard>
                                <br />
                                <CRow>
                                    <CCol v-if="report === 'Not available yet.'" sm="6">
                                        <CRow class="text-center m-0">
                                            <CChartDoughnut :datasets="defaultDatasets" />
                                            <br />
                                            <span class="text-center ml-2">No data available.</span>
                                        </CRow>
    
                                    </CCol>
    
                                    <CCol v-else sm="6" v-for="(dataset, index) in datasets" :key="index">
                                        <div class="text-center">
                                            <CChartDoughnut :datasets="[dataset]" :labels="[dataset.label]" />
                                        </div>
                                    </CCol>
    
    
    
                                </CRow>
                                <br />
                            </CCard>
    
                            <CCard>
                                <h3 class="custom-14px-400 font-inter m-2">Overall performance</h3>
    
                                <CChartRadar :datasets="radarChartData.datasetsRadar" :options="defaultOptionsRadar" :labels="radarChartData.labels" />
                                <br />
                            </CCard>
                        </CCol>
                        <CCol sm="7" class="p-0">
                            <CCol sm="12">
                                <h3 class="custom-18px-500 font-inter mt-2">Detail Explanation & Score</h3>
                                <h3 class="custom-14px-400 font-inter">Ranked based on users answer</h3>
                                <CCard>
    
                                    <CRow class="m-2">
                                        <CCol v-if="report === 'Not available yet.'" sm="6">
                                            <p>No data available.</p>
                                        </CCol>
                                        <CCol v-else sm="6" v-for="(trait, index) in report" :key="index">
                                            <div>
                                                <CRow class="mt-2">
                                                    <CCol sm="8">
                                                        <h4 class="custom-18px-600 font-color-171717 font-inter font-small">{{ trait.Type }}</h4>
                                                    </CCol>
                                                    <CCol sm="4">
                                                        <h4 class="custom-16px-500 font-color-171717 font-inter">{{ trait.Value }} /10</h4>
                                                    </CCol>
    
                                                    <CCol sm="12">
                                                        <p class="custom-14px-400 mt-2 font-color-171717">{{ trait.Details }}</p>
                                                    </CCol>
                                                    <CCol sm="12">
                                                        <CProgress :value="trait.Value" show-percentage color="success" max="10" :animated="animate" class="mb-2" />
                                                    </CCol>
                                                </CRow>
                                            </div>
                                        </CCol>
                                    </CRow>
                                </CCard>
                            </CCol>
                        </CCol> -->
    
                    </CRow>
    
                    <CCol sm="12">
                        <p class="custom-14px-400 font-color-191919">⭐ {{ averageRating }} Rate</p>
                        <h3 class="custom-14px-400 font-color-191919">⭐ Summary</h3>
                        <h4 class="custom-14px-400 font-color-191919" v-if="reportSummary != null">
                            <div v-html="formattedSummary" class="custom-14px-400 font-color-191919"></div>
    
                        </h4>
    
                    </CCol>
    
                    <br /> <br /> <br /> <br />
    
                </CContainer>
                <Footerlayout />
            </div>
        </CContainer>
    
    </div>
</template>


<script>
import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheBottomCustom.vue";
import { CChartDoughnut } from '@coreui/vue-chartjs';
import { CChartRadar } from '@coreui/vue-chartjs'
export default {
    components: {
        Mainlayout,
        Footerlayout,
        CChartDoughnut,
        CChartRadar
    },
    data() {
        return {
            questionVideo: {
                IndexNo: 0,
                SessionId: null
            },
            selectedVideo: null,
            isPopupDetail: false,
            isPopupDelete: false,
            isPopupShareLink: false,
            isPopupSuccess: false,
            index: 0,
            index1: 1,
            showVideo: true,
            report: [],
            reportRadar: [],
            reportRank: [],
            reportSummary: '',
            datasets: [],
            maxScore: 10, // Maximum score possible
            max: 10,
            options: {
                plugins: {
                    legend: {
                        display: false // Hides the legend
                    },
                    tooltip: {
                        enabled: true, // Enables tooltip
                        callbacks: {
                            label: function(context) {
                                // Display only value inside the tooltip
                                const value = context.raw || 0;
                                return `${value}`;
                            }
                        }
                    },
                    datalabels: {
                        display: function(context) {
                            // Show datalabels only for the value part
                            return context.dataIndex === 0;
                        },
                        formatter: function(value) {
                            return value; // Display the value
                        },
                        color: '#000', // Set text color
                        font: {
                            size: 14, // Set font size
                            weight: 'bold' // Set font weight
                        }
                    }
                }
            },
            radarChartData: {
                labels: [],
                datasetsRadar: [{
                    label: 'AI Video Score',
                    backgroundColor: 'rgba(44,184,92, 0.25)',
                    borderColor: 'rgba(44,184,92,255)',
                    data: []
                }],
            },
            defaultOptionsRadar: {
                aspectRatio: 1.5,
                scales: {
                    r: {
                        angleLines: { display: true },
                        ticks: {
                            suggestedMin: 1, // Adjusted minimum value
                            suggestedMax: 10,
                            beginAtZero: false,
                            stepSize: 2
                        }
                    }
                }
            },
            averageRating: 0, // Store the average rating
            totalCategories: 0, // Store the total number of categories
            totalPossibleScore: 0, // Store the total possible score (categories * 10)
            posit: {}
        };
    },
    computed: {
        defaultDatasets() {
            return [{
                backgroundColor: [

                    '#2cb85c'
                ],
                data: [100]
            }]
        },
        formattedSummary() {
            if (!this.reportSummary) return '';

            let text = this.reportSummary;

            // Step 1: Replace headings like **Heading:**
            text = text.replace(/\*\*(.*?)\n?\*\*/gs, (_, title) => {
                return `<br>🔹 <strong>${title.trim()}</strong><br>`;
            });

            // Step 2: Replace "* Label: Value" into styled <li>
            text = text.replace(/^\* (.*?): (.*)$/gm, '<li><strong>$1:</strong> $2</li>');

            // Step 3: Replace single-line "Label: Value" like "Likelihood of Purchase: 5/10..."
            text = text.replace(/^([^:\n]+):\s*(\d+\/10.*?)$/gm, '<div><strong>$1:</strong> $2</div>');

            // Step 4: Replace remaining "* item" into <li>
            text = text.replace(/^\* (.*)$/gm, '<li>$1</li>');

            // Step 5: Wrap all <li> items into a <ul> (ensure it's only for <li> tags)
            text = text.replace(/(<li>.*?<\/li>)/gs, match => `<ul>${match}</ul>`);

            // Step 6: Remove any nested <ul> created by mistake (for properly formatting the list)
            text = text.replace(/(<ul>.*?<\/ul>)/gs, match => {
                return match.replace(/<\/ul>\s*<ul>/g, '').replace(/^<ul>|<\/ul>$/g, '');
            });

            // Step 7: Replace remaining newlines with <br>
            text = text.replace(/(<br>\s*){2,}/g, '<br>');

            const ratings = text.match(/\d+\/10/g); // Extract all ratings in the format X/10
if (ratings) {
    const totalRating = ratings.reduce((sum, rating) => sum + parseInt(rating.split('/')[0]), 0); // Sum all ratings
    this.totalCategories = ratings.length; // Set the number of categories
    this.totalPossibleScore = this.totalCategories * 10; // Total possible score (categories * 10)

    // Calculate the average on a 10-point scale
    this.averageRating = (totalRating / this.totalCategories).toFixed(1); // Calculate average rating
}
            return text;
        }
    },
    mounted() {
        const sessionId = this.$route.query.id;
        if (sessionId) {
            this.index = 1; // <-- Set index to 1 first
            this.getListQuestion(this.index, sessionId); // Then load index 1
            this.getReport(sessionId);
            this.getReportRadar(sessionId);
            this.getReportRank(sessionId);
            this.getReportSummaryRank(sessionId);
            this.getTitlePosition(sessionId);
        }
    },
    methods: {
        goBack() {
            if (window.history.length > 1) {
                this.$router.go(-1);
            }
        },
        openPopup(video) {
            this.selectedVideo = video;
            this.isPopupDetail = true;
        },
        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
        },
        deleteVideo() {
            this.isPopupDelete = true;
        },
        shareVideo() {
            this.isPopupShareLink = true;
        },
        openSuccess() {
            this.isPopupSuccess = true;
            this.isPopupDelete = false;
        },
        async nextQuestion(index) {
            this.index = index + 1;
            this.showVideo = false;
            const sessionId = this.$route.query.id;
            this.getListQuestion(this.index, sessionId);

        },
        async getListQuestion(index, sessionId) {
            try {
                const response = await this.$API.get(
                    `${this.$GetNextQuestionVideo}/${sessionId}/${index}`, { withCredentials: true }
                );
                if (response.status === 200) {
                    this.questionVideo = response.data;
                }
            } catch (error) {
                console.error("Failed to fetch question video", error);
            }
        },
        async getReport(sessionId) {
            try {
                const response = await this.$API.get(this.$GetRank + "?session_id=" + sessionId);
                if (response.status === 200) {
                    this.report = response.data;
                    //this.processReportData(this.report);
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        async getReportRadar(sessionId) {
            try {
                const response = await this.$API.get(this.$GetRank + "?session_id=" + sessionId);
                if (response.status === 200) {
                    this.reportRadar = response.data;
                    this.processReportData(this.report);
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        processReportData() {
            // Extract Type and Value for labels and data
            this.radarChartData.labels = [...this.reportRadar.map(item => item.Type)];
            this.radarChartData.datasetsRadar[0].data = [...this.reportRadar.map(item => item.Value)];
        },
        async getReportRank(sessionId) {
            try {
                const response = await this.$API.get(this.$GetRank + "?session_id=" + sessionId);
                if (response.status === 200) {
                    // const relevantTypes = ['Attitude', 'Communication', 'Sociability', 'Teamwork'];
                    this.reportRank = response.data;
                    console.log("rank" + this.reportRank);
                    this.prepareChartData(this.reportRank);
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        async getReportSummaryRank(sessionId) {
            try {
                const response = await this.$API.get(this.$SessionSummary + "?session_id=" + sessionId);
                if (response.status === 200) {
                    this.reportSummary = this.reformatSummary(response.data.Summary);
                } else {
                    // Handle non-200 status code
                    this.reportSummary = null;
                }
            } catch (error) {
                // Handle the error here
                this.reportSummary = null;
            }
        },
        async getTitlePosition(sessionId) {
            try {
                const response = await this.$API.get(this.$SessionSummary + "?session_id=" + sessionId);
                if (response.status === 200) {
                    this.posit = response.data;
                } else {
                }
            } catch (error) {
                // Handle the error here
                this.reportSummary = null;
            }
        },
        reformatSummary(summaryText) {
            return summaryText ? summaryText.replace(/:/g, ':\n') : null;
        },
        prepareChartData() {
            // const relevantCategories = ['Attitude', 'Communication', 'Sociability', 'Teamwork'];
            const maxScore = 10;

            this.datasets = this.reportRank
                // .filter(item => relevantCategories.includes(item.Type))
                .map(trait => ({
                    data: [trait.Value * 10, (maxScore - trait.Value) * 10],
                    backgroundColor: ['#2cb85c', '#E0E0E0'],
                    label: trait.Type
                }));
        },

    }
};
</script>

